import {gql} from '@apollo/client';

export const FRAGMENT_FORUM_ITEM = gql`
  fragment ForumItem on ForumType {
    id
    name
    content
    commentsCount
    likesCount
    viewsCount
    closed
    createdAt
    user {
      id
      fullname
      avatar {
        id
        path
      }
    }
    tags {
      id
      lesson {
        id
        name
      }
    }
  }
`;

export const QUERY_FORUM_LIST = gql`
  query ForumList($search: String, $lessons: String, $isClosed: Boolean) {
    forumList(search: $search, tags_Lesson_In: $lessons, closed: $isClosed) {
      ...ForumItem
    }
  }
  ${FRAGMENT_FORUM_ITEM}
`;

export const QUERY_FORUM_DETAIL = gql`
  query ForumDetail($id: ID!) {
    forumDetail(id: $id) {
      ...ForumItem
    }
  }
  ${FRAGMENT_FORUM_ITEM}
`;

export const MUTATION_FORUM_SAVE = gql`
  mutation ForumSave($input: ForumSaveInput!) {
    forumSave(input: $input) {
      obj {
        ...ForumItem
      }
      errors {
        field
        messages
      }
    }
  }
  ${FRAGMENT_FORUM_ITEM}
`;

export const MUTATION_FORUM_CLOSE = gql`
  mutation ForumClose($input: ForumCloseInput!) {
    forumClose(input: $input) {
      obj {
        id
        closed
      }
    }
  }
`;
